import { render, staticRenderFns } from "./MappingListMessages.vue?vue&type=template&id=e7690546&"
import script from "./MappingListMessages.vue?vue&type=script&lang=js&"
export * from "./MappingListMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListTile } from 'vuetify/lib/components/VList';
installComponents(component, {VListTile})
